import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import Wrapper from '../Wrapper';
import Loader from '../../components/Loader/Loader';

const EnrollStudentsDetails = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [studentData, setStudentData] = useState(null);
  const { id, email } = useParams();
  


  useEffect(() => {
    setIsLoaded(true);

    if (id && email) {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        email: email,
        courseId: id
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch('https://quran-backend-theta.vercel.app/v1/user/signle-enrolled-course', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data?.success === false) {
          
            setIsLoaded(false);
            toast.error(data?.error);
          }
          setStudentData(data);
          setIsLoaded(false);
        })
        .catch((error) => {
          console.error(error);
          toast.error(error);
          setIsLoaded(false);
        });
    }
  }, [id, email]);


  const [loader, setLoader] = useState(true);
  const [isModelLoading, setIsModelLoading] = useState(false);
  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);
  const [singleData, setSingleData] = useState({});
  const [students, setStudents] = useState([]);

  const [singleStudent, setSingleStudents] = useState({})

  useEffect(() => {
    fetchAllStudentInCourse();
  }, [email]);

  const fetchAllStudentInCourse = () => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/student-history?email=${email}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        
        
                
        setStudents(result?.enrollments);
        setSingleStudents(result?.student)

      })
      .catch((error) => {
        console.error(error);
        toast.error('Failed to fetch students');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleChangeStatus = async (newStatus, studentId) => {
    setStudents((prevStudents) =>
      prevStudents.map((student) =>
        student._id === studentId ? { ...student, isLoading: true } : student
      )
    );

    try {
      const res = await axios.patch(
        `https://quran-backend-theta.vercel.app/v1/admin/update-enrollment-status/${studentId}`,
        {
          newStatus: newStatus
        }
      );



      if (res.data.success) {
        setStudents((prevStudents) =>
          prevStudents.map((student) =>
            student._id === studentId
              ? { ...student, status: newStatus, isLoading: false }
              : student
          )
        );
      } else {
        console.error(res.data.message);
      }
    } catch (error) {
      console.error('Error updating status:', error);
    } finally {
      setStudents((prevStudents) =>
        prevStudents.map((student) =>
          student._id === studentId ? { ...student, isLoading: false } : student
        )
      );
    }
  };

  const ApproveFee = (link) => {
    setIsModelLoading(true);

    const requestOptions = {
      method: 'PATCH',
      redirect: 'follow'
    };

    fetch(
      `https://quran-backend-theta.vercel.app/v1/admin/fee-mark-paid/${link?._id}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        if (data?.success === false) {
          toast.error(data?.error);
          setIsModelLoading(false);
        }
        setIsModelLoading(false);
        toast.success('Fee is Paid');
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error);
        setIsModelLoading(false);
      });
  };

  const closeModal = () => {
    setIsSlipModalOpen(!isSlipModalOpen);
  };



  return (
    <Wrapper>
      <h2 className="main_title ">Student Details</h2>
      <p className=" text-[#1C1D1D]">Here are details of the Student</p>

      <div className=" p-3 mt-10 rounded-lg" style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}>

        {studentData ? (
          <>
            <div className=" flex justify-between items-center">
              <div>
                <span className=" m-0 text-gray-400 text-sm">Student Name</span>
                <h6 className=" text-lg">{studentData?.data?.enrollment?.studentName}</h6>{' '}

              </div>
              <div>
                <span className=" m-0   text-gray-400 text-sm">Time</span>
                <h6 className=" text-lg">
                  {studentData?.data?.assignment?.timeSlots?.map((item, index) => {
                    return (
                      <div key={index}>
                        <p className="">
                          {item?.startTime} - {item?.endTime}
                        </p>
                      </div>
                    );
                  })}
                </h6>{' '}

              </div>
            </div>
            <span className=" m-0 text-gray-400 text-sm">Father Name</span>
            <h6 className=" text-lg">{studentData?.data?.enrollment?.fatherName}</h6>{' '}

            <span className=" m-0 text-gray-400 text-sm">Age</span>
            <h6 className=" text-lg">{studentData?.data?.user?.age}</h6>
            <span className=" m-0 text-gray-400 text-sm">Address</span>
            <h6 className=" text-lg">{studentData?.data?.user?.address}</h6>{' '}
            {/* Assuming address field */}
            <span className=" m-0 text-gray-400 text-sm">Country</span>
            <h6 className=" text-lg">{studentData?.data?.user?.country}</h6>{' '}
            {/* Assuming country field */}
            {/* Assuming address field */}

            <span className=" m-0 text-gray-400 text-sm">Email</span>
            <h6 className=" text-lg">{studentData?.data?.user?.email}</h6>{' '}

            <span className=" m-0 text-gray-400 text-sm">Password</span>
            <h6 className=" text-lg">{studentData?.data?.user?.password}</h6>{' '}
            {/* Assuming country field */}
            <span className=" m-0 text-gray-400 text-sm">Phone Number</span>
            <h6 className=" text-lg">{studentData?.data?.user?.phoneNumber}</h6>{' '}
            <span className=" m-0 text-gray-400 text-sm">Whatsapp Number</span>
            <h6 className=" text-lg">{studentData?.data?.user?.whatsappNumber}</h6>{' '}
            {/* Assuming phone field */}
            <span className=" m-0 text-gray-400 text-sm">Payment</span>
            <h6 className=" text-lg text-green">
              Due Date: {moment(studentData?.data?.enrollment?.nextPaymentDate).format('MMM Do YY')}
            </h6>{' '}
            {/* Assuming paymentDueDate field */}
          </>
        ) : (
          <div>No student data available</div> // Show a fallback if no data is available
        )}
      </div>



      <section className="mb-20 mt-7">
        <h2 className="main_title ">Student Course Enrollment</h2>
        <p className=" text-[#1C1D1D] pb-7">Here are details of the Student Course Enrollment</p>
        <div className="rounded-lg overflow-x-auto">
          {loader ? ( // Show loader while fetching data
            <Loader />
          ) : students.length > 0 ? ( // Render student list if data is available
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className="rounded-lg whitespace-nowrap">
                          <th className="text-sm text-primary font-bold px-6 py-4">ID</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Father Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Phone no</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Country</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Teacher</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Timing</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Admission Date</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {students.map((student, index) => (
                          <tr
                            key={student?._id}
                            style={{ boxShadow: '0px 0px 63.44px 0px #00000012' }}
                            className="bg-white border-b-8 border-white rounded-md"
                          >
                            {/* ID */}
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {`100${index + 1}`}
                              </span>
                            </td>

                            {/* Name */}
                            <td className="text-sm bg-white font-normal text-center px-6 py-4 whitespace-nowrap">
                              <Link
                                to={`/student-fee-attendance/${student?._id}/${id}/${singleStudent?._id}/${student?.studentName}`}
                                className="text-base text-secondary py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full"
                              >
                                {student?.studentName}
                              </Link>
                            </td>

                            {/* Father Name */}
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student?.fatherName}
                              </span>
                            </td>

                            {/* Phone Number */}
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student?.number}
                              </span>
                            </td>

                            {/* Country */}
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student?.country}
                              </span>
                            </td>

                            {/* Teacher */}
                            <td className="align-middle bg-white font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {student?.assignments?.[0]?.teacher?.name}
                              </span>
                            </td>
                            <td className="align-middle bg-white font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {`${student?.assignments?.[0]?.timeSlots?.[0]?.startTime}-${student?.assignments?.[0]?.timeSlots?.[0]?.endTime}`}
                              </span>
                            </td>
                            <td className="align-middle bg-white font-normal px-6 py-4 whitespace-nowrap">
                              <span className="text-base text-black py-1 px-2.5 leading-none whitespace-nowrap bg-green-200 rounded-full">
                                {moment(student?.admissionDate).format('DD-MM-YYYY h:m:s')}
                              </span>
                            </td>



                            {/* Payment */}
                            {/* <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                                  {student?.feeStatus?.status === '-' ? (
                                    // Case 1: Fee status is "-".
                                    <span className="text-base text-secondary py-1 px-2.5 leading-none whitespace-nowrap">
                                      {student?.nextPaymentDate
                                        ? moment(student?.nextPaymentDate).format('MMM Do YY')
                                        : 'N/A'}
                                    </span>
                                  ) : student?.feeStatus?.status === 'paid' ? (
                                    // Case 2: Fee status is "paid".
                                    (() => {
                                      const slipPayDate = moment(student?.feeStatus?.slipPayDate);
                                      const nextPaymentDate = moment(student?.nextPaymentDate);
                                      const diffDays = nextPaymentDate.diff(slipPayDate, 'days');
      
                                      return (
                                        <span
                                          style={{
                                            color: diffDays > 30 ? 'red' : 'inherit',
                                          }}
                                          className="text-base"
                                        >
                                          {moment(student?.nextPaymentDate).format('MMM Do YY')}
                                        </span>
                                      );
                                    })()
                                  ) : (
                                    // Case 3: Other statuses, show Approve Fee Slip link.
                                    <a
                                      onClick={() => {
                                        setIsSlipModalOpen(true);
                                        setSingleData(student);
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-base text-[#FF7E00] cursor-pointer"
                                    >
                                      Approve Fee Slip
                                    </a>
                                  )}
                              
                                {/* Status */}
                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              {/* {student?.isLoading ? (
                                    <span className="ml-2 text-gray-500">Loading...</span>
                                  ) : (
                                    <select
                                      className={`px-3 py-2 rounded-md ${student?.status === 'approved'
                                        ? 'bg-[#DFF7E3] text-[#23A118]'
                                        : 'bg-[#FCE8E6] text-[red]'
                                        }`}
                                      value={student?.status}
                                      onChange={(e) => handleChangeStatus(e.target.value, student?._id)}
                                    >
                                      <option value="pending">Pending</option>
                                      <option value="approved">Approved</option>
                                      <option value="inactive">Inactive</option>
                                      <option value="completed">Complete</option>
                                    </select>
                                  )} */}

                              <span
                                className={`text-base py-1 px-2.5 leading-none whitespace-nowrap rounded-md ${student.status === 'pending'
                                    ? 'bg-[#DFF7E3] text-[#23A118]'
                                    : student.status === 'completed'
                                      ? 'bg-[#FFE4E4] text-[#FF0000]'
                                      : student.status === 'approved'
                                        ? 'bg-[#FFF3E0] text-[#FFA500]'
                                        : student.status === 'inactive'
                                          ? 'bg-[#E0F7FA] text-[#00BCD4]'
                                          : 'bg-gray-200 text-black'
                                  }`}
                              >
                                {student.status}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // Show "No students found" message if data is empty
            <div className="text-center py-10">
              <p className="text-gray-500">No students found for this course.</p>
            </div>
          )}
        </div>

        {/* Fee Slip Modal */}
        {isSlipModalOpen && (
          <>
          
            <div
              className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
              onClick={closeModal}
            >
              <div
                className="bg-white p-6 rounded overflow-y-auto h-[60vh] shadow-lg max-w-xl w-full relative"
                onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
              >
                {/* X Icon for closing */}
                <button
                  onClick={closeModal}
                  className="absolute top-2 right-2 text-gray-500 hover:text-red-500"
                >
                  ✕
                </button>

                <h2 className="text-lg font-bold mb-4">Fee Slip</h2>

                <div className="w-full mb-6">
                  <img
                    src={singleData?.feeStatus?.slipUrl}
                    alt="Fee Slip"
                    className="w-full h-auto rounded mb-4"
                  />
                </div>

                <div className="flex justify-end gap-4">
                  {/* Cancel Button */}
                  <button
                    onClick={closeModal}
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                  >
                    Cancel
                  </button>

                  {/* Approve Button */}
                  <button
                    onClick={() => ApproveFee(singleData)}
                    className="px-4 py-2 bg-[#FF7E00] text-white rounded"
                    disabled={isModelLoading} // Disable button during loading
                  >
                    {isModelLoading ? (
                      <div className="spinner-border animate-spin w-5 h-5 border-t-2 border-white rounded-full" />
                    ) : (
                      'Approve'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </section>
    </Wrapper>
  );
};

export default EnrollStudentsDetails;
